module.exports = __webpack_public_path__ + "images/emoji/blue_car.d52e576063b3ccd3ae9f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blue_car.png
// module id = x8AU
// module chunks = 24